/**
* JS which improves customer experience for BOU
* 
*/

$(document).ready(function(){
/**
* attempt to fix carousel for click and mouseover function
*/ 
  $('#airsoft-collection').on('mouseover',function(){
    // Manually refresh positioning of slick
    $('.slider-home').slick('slickGoTo',0);
    $('.cmd-collection').removeClass('slick-current');
    $(this).addClass('slick-current');
    //console.log($('.slider-home').slick('slickCurrentSlide'));
  });
  
  $('#pellet-collection').on('mouseover',function(){
    // Manually refresh positioning of slick
    $('.slider-home').slick('slickGoTo',1);
        $('.cmd-collection').removeClass('slick-current');
    $(this).addClass('slick-current');
    
  });
  
  $('#gear-collection').on('mouseover',function(){
    // Manually refresh positioning of slick
    $('.slider-home').slick('slickGoTo',2);
        $('.cmd-collection').removeClass('slick-current');
    $(this).addClass('slick-current');
    
  });  

  
  //handle click
  $('#airsoft-collection').on('click',function(){
	window.location =$(this).attr('data-href');

  });
  
  $('#pellet-collection').on('click',function(){
	window.location =$(this).attr('data-href');
  });
  
  $('#gear-collection').on('click',function(){
	window.location =$(this).attr('data-href');
  });  
  
  //
  //Handle auto parent slide
  //

  $('.slider-home').on('afterChange', function(event, slick, currentSlide, nextSlide){
    //switch
    switch(currentSlide){
      case 0:
        $('.cmd-collection').removeClass('slick-current');
        $('#airsoft-collection').addClass('slick-current');        		
      break;
      case 1:
		$('.cmd-collection').removeClass('slick-current');
        $('#pellet-collection').addClass('slick-current');        	
      break;
      case 2:
        $('.cmd-collection').removeClass('slick-current');
        $('#gear-collection').addClass('slick-current');  
       break;
    }
  });
  

//
//Remove date on reviews
//
  //var reviewContent = $('.spr-review-header-byline');
  //var reviewName = $('.spr-review-header-byline strong:first').text();
  //console.log(reviewName);
  
//
//Handle Product Titles based on len
//
  
});
